<template>
  <div class="c-partner-mapping-rule-card">
    <h2 class="c-partner-mapping-rule-card__title">{{ title }}</h2>
    <p v-if="subtitle" class="c-partner-mapping-rule-card__subtitle">
      {{ subtitle }}
    </p>
    <PartnerMappingSingleFilter
      ref="filterRef"
      :feed-id="feedId"
      :disabled="isDisabled"
      :hide-actions="!hasFilterActions"
    />
    <slot name="footer" />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

import PartnerMappingSingleFilter from './PartnerMappingSingleFilter.vue';

const {
  feedId,
  title,
  subtitle,
  isDisabled = false,
  hasFilterActions = true,
} = defineProps<{
  feedId: number;
  title: string;
  subtitle?: string;
  isDisabled?: boolean;
  hasFilterActions?: boolean;
}>();

const filterRef = ref<InstanceType<typeof PartnerMappingSingleFilter> | null>(
  null,
);

const hasValidChanges = computed(
  () => filterRef.value?.hasValidChanges ?? false,
);
const sourceFilterExpressions = computed(
  () => filterRef.value?.sourceFilterExpressions ?? null,
);

function save(): Promise<boolean> {
  return filterRef.value?.save() ?? Promise.resolve(false);
}

defineExpose({ save, hasValidChanges, sourceFilterExpressions });
</script>

<style lang="pcss" scoped>
@reference "../../../../../css/theme.css";
.c-partner-mapping-rule-card {
  @apply bg-neutral-background-weak rounded-8 p-16 flex flex-col;
}

.c-partner-mapping-rule-card__title {
  @apply text-neutral-900 text-[1rem] font-bold mb-8;
}

.c-partner-mapping-rule-card__subtitle {
  @apply text-neutral-text-weak text-base mb-16;
}
</style>
